import React from 'react';
import PropTypes from 'prop-types';
import { classnames } from '../../utils/classnames'

import './label-details.css';

export function LabelDetailsContainer({ className = '', children = null }) {
    return <div className={classnames('label-details__container', className)}>{children}</div>;
}

LabelDetailsContainer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};

export default function LabelDetails({ className = '', title = '', children = null }) {
    return (
        <div className={classnames('label-details', className)}>
            <span className={'label-details__title'}>{title}</span>
            {children && <span className={'label-details__children'}>{children}</span>}
        </div>
    );
}

LabelDetails.propTypes = {
    title: PropTypes.node,
    className: PropTypes.string,
    children: PropTypes.node
};

LabelDetails.Container = LabelDetailsContainer;
